import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {environment} from "@environments/environment";
import {Result} from "@domain/common/http/result";
import {MobileConfig} from "@domain/admin/parametre/mobilite/MobileConfig";

/**
 * Service de gestion de la configuration de l'application mobile
 */
@Injectable()
export class MobileConfigService {

    /**
     * Constructeur
     *
     * @param http Service HTTP
     */
    constructor(private http: HttpClient) {
    }

    /**
     * Chargement de la configuration mobile
     */
    loadConfig(): Observable<Result> {
        return this.http.post<Result>(`${environment.baseUrl}/controller/MobileConfig/loadConfig`,null);
    }

    /**
     * Enregistrement de la configuration mobile
     *
     * @param config Configuration à enregistrer
     */
    saveConfig(config: MobileConfig): Observable<Result> {
        return this.http.post<Result>(`${environment.baseUrl}/controller/MobileConfig/saveConfig`,config);
    }
}
